import { useEffect } from "react";
import { gtag } from "ga-gtag";

export default function Conversion() {
  useEffect(() => {
    if (typeof window !== "undefined") {
      const { Snipcart } = window;
      console.log("conversion initialized");

      if (Snipcart !== undefined && Snipcart !== "undefined") {
        Snipcart.events.on("cart.confirmed", (cartConfirmResponse) => {
          // Track overall order completion with cart total
          console.log("order completed");

          gtag("event", "conversion", {
            send_to: "AW-11012634547/LhXjCMmU96kbELPvnYMp",
            value: cartConfirmResponse.total,
            currency: "EUR",
            transaction_id: cartConfirmResponse.invoiceNumber,
          });

          // Check for redirect parameter and redirect after delay
          const urlParams = new URLSearchParams(window.location.search);
          const redirectUrl = urlParams.get("redirect");

          if (redirectUrl) {
            console.log(`Redirecting to ${redirectUrl} in 3 seconds...`);
            setTimeout(() => {
              window.location.href = redirectUrl;
            }, 3000); // 3 second delay to show completion screen
          }
        });
      }
    }
  }, []);

  return null;
}
